import { Tooltip as MuiTooltip } from '@mui/material';

const CustomXAxisTick = ({ x, y, payload }) => {
    const text = payload.value;
    const maxLength = 20;
    const displayText =
        text.length > maxLength ? text.slice(0, maxLength) + '…' : text;

    return (
        <g transform={`translate(${x},${y + 10})`}>
            <MuiTooltip title={text}>
                <text
                    x={0}
                    y={0}
                    dy={16}
                    textAnchor="end"
                    fill="#666"
                    transform="rotate(-35)"
                    style={{ cursor: 'default', fontSize: 11 }}
                >
                    {displayText}
                </text>
            </MuiTooltip>
        </g>
    );
};

export default CustomXAxisTick;
